import DeltaWifiEditorial from './DeltaWifiEditorial';

export default DeltaWifiEditorial;
